// AdminReportDashboard.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { adminAPI } from '../../services/api';
import toast from 'react-hot-toast';
import TemplateManager from './components/TemplateManager';
import ReportGenerator from './components/ReportGenerator';
import ReportHistory from './components/ReportHistory';

const AdminReportDashboard = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('templates');
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({});

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const response = await adminAPI.getResultTemplates();
      setTemplates(response.data);
      
      // Get stats
    //   const statsRes = await adminAPI.getReportStats();
    //   setStats(statsRes.data);
    } catch (error) {
        console.log(error)
      toast.error('Failed to load templates');
    } finally {
      setLoading(false);
    }
  };

  const handleTemplateUpload = async (templateData) => {
    try {
      await adminAPI.uploadTemplate(templateData);
      toast.success('Template uploaded successfully');
      fetchTemplates();
    } catch (error) {
      toast.error('Failed to upload template');
    }
  };

  const handleGenerateReport = async (config) => {
          const id = toast.loading('Generating report...');
    try {
    //   toast.loading('Generating report...');

      
      if (config.type === 'single') {
        const response = await adminAPI.generateStudentPDF(config);
        downloadPDF(response.data, `report_${config.student_reg}.pdf`);
      } else {
        const response = await adminAPI.generateBulkPDF(config);
        downloadZIP(response.data, `reports_class_${config.class_id}.zip`);
      }
      toast.dismiss(id);
      toast.success('Report generated successfully');
    } catch (error) {
        toast.dismiss(id);
      toast.error('Failed to generate report');
    }
  };

  const downloadPDF = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const downloadZIP = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-6 text-white">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold">Report Management</h1>
            <p className="opacity-90 mt-1">Generate and manage student result reports</p>
          </div>
          <div className="hidden md:block">
            <i className="fas fa-file-pdf text-5xl opacity-20"></i>
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      {/* <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-white rounded-lg shadow p-4">
          <div className="flex items-center">
            <div className="p-3 bg-blue-100 rounded-lg mr-4">
              <i className="fas fa-file-alt text-blue-600 text-xl"></i>
            </div>
            <div>
              <p className="text-sm text-gray-500">Templates</p>
              <p className="text-2xl font-bold">{stats.templates || 0}</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow p-4">
          <div className="flex items-center">
            <div className="p-3 bg-green-100 rounded-lg mr-4">
              <i className="fas fa-user-graduate text-green-600 text-xl"></i>
            </div>
            <div>
              <p className="text-sm text-gray-500">Students</p>
              <p className="text-2xl font-bold">{stats.total_students || 0}</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow p-4">
          <div className="flex items-center">
            <div className="p-3 bg-purple-100 rounded-lg mr-4">
              <i className="fas fa-chart-bar text-purple-600 text-xl"></i>
            </div>
            <div>
              <p className="text-sm text-gray-500">Reports Generated</p>
              <p className="text-2xl font-bold">{stats.reports_generated || 0}</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow p-4">
          <div className="flex items-center">
            <div className="p-3 bg-yellow-100 rounded-lg mr-4">
              <i className="fas fa-database text-yellow-600 text-xl"></i>
            </div>
            <div>
              <p className="text-sm text-gray-500">Storage Used</p>
              <p className="text-2xl font-bold">{stats.storage_used || '0MB'}</p>
            </div>
          </div>
        </div>
      </div> */}

      {/* Tab Navigation */}
      <div className="bg-white rounded-lg shadow">
        <div className="border-b">
          <nav className="flex -mb-px">
            <button
              onClick={() => setActiveTab('templates')}
              className={`py-4 px-6 font-medium text-sm border-b-2 ${
                activeTab === 'templates'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              <i className="fas fa-file-code mr-2"></i>
              Template Manager
            </button>
            <button
              onClick={() => setActiveTab('generate')}
              className={`py-4 px-6 font-medium text-sm border-b-2 ${
                activeTab === 'generate'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              <i className="fas fa-cogs mr-2"></i>
              Generate Reports
            </button>
            {/* <button
              onClick={() => setActiveTab('history')}
              className={`py-4 px-6 font-medium text-sm border-b-2 ${
                activeTab === 'history'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              <i className="fas fa-history mr-2"></i>
              Report History
            </button> */}
            {/* <button
              onClick={() => setActiveTab('settings')}
              className={`py-4 px-6 font-medium text-sm border-b-2 ${
                activeTab === 'settings'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              <i className="fas fa-cog mr-2"></i>
              Settings
            </button> */}
          </nav>
        </div>

        <div className="p-6">
          {activeTab === 'templates' && (
            <TemplateManager
              templates={templates}
              onUpload={handleTemplateUpload}
            />
          )}
          
          {activeTab === 'generate' && (
            <ReportGenerator
              templates={templates}
              onGenerate={handleGenerateReport}
            />
          )}
          
          {activeTab === 'history' && (
            <ReportHistory />
          )}
          
          {activeTab === 'settings' && (
            <div className="space-y-4">
              <h3 className="text-lg font-semibold">Report Settings</h3>
              {/* Settings form */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminReportDashboard;